import { Theme } from '@chakra-ui/react'
import { DeepPartial } from '../../../common/types'

interface NucbaInput extends DeepPartial<Theme['components']['Input']> {}

const filledBgColor = {
  backgroundColor: 'nucba.black-70',
}

export const Input: NucbaInput = {
  baseStyle: {
    field: {
      width: 'auto',
    },
  },
  variants: {
    filled: {
      field: {
        ...filledBgColor,
        borderRadius: '26px',
        _focus: {
          ...filledBgColor,
        },
      },
    },
    outline: {
      field: {
        borderColor: 'nucba.borderColor',
        borderRadius: '4px',
      },
    },
  },
  defaultProps: {
    variant: 'filled',
  },
}
